export function logError(error: any) {
    if (window.console) {
        window.console.error(error);
    }
}

export function logException(ex: any) {
    if (window.console) {
        window.console.error(ex);
    }
}

export function logInfo(info: any, data: any = null) {
    if (window.console) {
        window.console.log(info, data);
    }
}